import createValidador from '../hooks/createValidador'

export const withValidador = (Component) => {
  const WithValidador = (props) => {
    const { Validador } = createValidador()

    return <Component Validador={Validador} {...props} />
  }

  WithValidador.displayName = `WithValidador(${Component.displayName || Component.name || 'Component'})`

  return WithValidador
}
